import { GetStaticPropsContext } from 'next'

import Main from '@/layouts/main'
import Section from '@/layouts/section'
import Block from '@/layouts/block'
import { H404, Q1 } from '@/components/typography'
import { ButtonLink } from '@/components/button'
import { getRvdbNavigationData } from '@/services/contentful/api'

const Custom404 = () => (
  <Main withGradient>
    <Section className="pt-20 pb-40 px-10 lg:py-10 flex bg-white rounded-[20px] flex-col lg:flex-row justify-start lg:justify-center !max-w-[1360px]">
      <Block className="lg:flex-1 order-2 lg:order-1 flex flex-col justify-center items-center lg:items-start lg:my-28">
        <Q1 variant="rvdb" className="mb-10 text-center lg:text-left">
          Oeps, foutje!
          <br /> Deze pagina lijkt niet te bestaan.
        </Q1>
        <ButtonLink href="/">Ga naar de homepagina</ButtonLink>
      </Block>
      <Block className="lg:flex-1 order-1 lg:order-2 mb-10 lg:mb-0 grid place-items-center">
        <H404>404</H404>
      </Block>
    </Section>
  </Main>
)

export async function getStaticProps({ preview }: GetStaticPropsContext) {
  const isPreview: boolean = !!preview ?? false

  const { data: navData, error: navError } = await getRvdbNavigationData(
    isPreview
  )

  return {
    props: {
      data: { navData, pageData: null },
      error: { navError, pageError: null },
    },
    revalidate: 60,
  }
}

export default Custom404
